<template>
  <el-dialog
    :append-to-body="true"
    :title="drawerTitle"
    :visible.sync="show"
    direction="ltr"
    :wrapperClosable="false"
    :before-close="handleClose"
    width="700"
    >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm form-box"
    >
      <el-form-item label="会议名称:" prop="cloudMeetingName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.cloudMeetingName"
          placeholder="请输入会议名称"
          clearable
          :disabled="drawerType == 'info' ? true : false"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="会议内容:" prop="cloudMeetingContent">
        <el-input
          style="width:95%"
          type="textarea"
          v-model.trim="ruleForm.cloudMeetingContent"
          placeholder="请输入会议内容"
          clearable
          :disabled="drawerType == 'info' ? true : false"
        
        ></el-input>
      </el-form-item>
     
      <el-form-item label="会议时间:" >
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="timestamp"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="会议封面:" prop="cloudMeetingCover">
        <div class="image-show-box" v-if="drawerType == 'info'">
          <el-image
            class="image-box"
            v-for="(item, index) in srcList"
            :key="index"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
        <upload-image
          v-else
          v-model="ruleForm.cloudMeetingCover"
          :uploadLimit="1"
          accept="image/jpg, image/png, image/jpeg"
          style="width:95%"
        ></upload-image>
      </el-form-item>
      
    </el-form>
    <div class="save-box">
      <el-button type="primary" size="small" @click="saveClick('ruleForm')"
        >提交</el-button
      >
      <el-button size="small" @click="cancelClick">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import UploadImage from "./UploadImage";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    UploadImage
  },
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false
      }
    },
    drawerType: {
      type: String,
      default: {
        return: ""
      }
    },
    initialData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    var num = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    //这里存放数据
    return {
      show: false,
      rules: {
        cloudMeetingName: [{ required: true, message: " ", trigger: "blur" }],
        cloudMeetingContent: [{ required: true, message: " ", trigger: "blur" }],
       
      },
      ruleForm: {
        cloudMeetingName: "",
        cloudMeetingContent:"",
        cloudMeetingStartTime:"",
        cloudMeetingEndTime:"",
        cloudMeetingStatus:0,
        cloudMeetingLiveAddress:"",
        cloudMeetingCover:"",
        cloudMeetingLivePlayback:"",
        cloudMeetingEdu: this.$store.getters.getUserInfo.eduId
      },
      dialogVisible: false,
      fileList: [],
      drawerTitle: "",
      srcList: [],
      value1:[]
    };
  },
  //监控data中的数据变化
  watch: {
    drawerShow: function(val) {
      this.show = val;
      if (val) {
        if (this.drawerType == "add") {
          this.drawerTitle = "新增会议";
        } else if (this.drawerType == "edit") {
          this.drawerTitle = "编辑会议";
        } else {
          this.drawerTitle = "会议详情";
        }
        // this.ruleForm = Object.assign({},);
      
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    //   关闭抽屉
    handleClose() {
      this.$emit("handleClose");
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        
          this.ruleForm.cloudMeetingStartTime = this.value1[0]/1000
          this.ruleForm.cloudMeetingEndTime = this.value1[1]/1000

          console.log(this.ruleForm, "----------");
          this.$emit("saveData", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    cancelClick() {
      this.handleClose();
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.form-box {
  width: 100%;
  height: calc(100% - 60px);
  overflow-y: scroll;
}
.save-box {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  
}
.upload-box {
  width: 100%;
}
.upload-box /deep/ .el-upload-list--picture-card {
  .el-upload-list__item {
    width: 78px;
    height: 78px;
  }
}
.upload-box /deep/ .el-upload--picture-card {
  width: 78px;
  height: 78px;
  line-height: 78px;
}
.image-show-box {
  display: flex;
  .image-box {
    margin-right: 10px;
    width: 100px;
    height: 100px;
    overflow-y: scroll;
  }
  .file-box {
    margin-right: 10px;
    width: 100px;
    height: 100px;
    overflow-y: scroll;
    background: url("~@/assets/img/img/pdf-icon.png") center center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
